import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { scheduleAListConstants } from "./scheduleAList.constants";

const initialState = {
	page: 0,
	queryParams: {
		pageIndex: 0,
	},
};

export const getScheduleAListState = state => state.scheduleAList;

//prettier-ignore
const selector = property =>
	fp.flow(getScheduleAListState, fp.property(property));

export const getScheduleAListPage = selector("queryParams.pageIndex");

export const getScheduleAListSortBy = selector("queryParams.sortBy");

export const getScheduleAListSortDescending = selector("queryParams.isDescending");


function scheduleAList(state = initialState, action) {
	switch (action.type) {

		case scheduleAListConstants.SET_SORTING:
			return {
				...state,
				queryParams: {
					...state.queryParams,
					isDescending: action.isDescending,
					sortBy: action.sortBy,
				},
			};
		case scheduleAListConstants.SET_PAGING:
			return {
				...state,
				queryParams: {
					...state.queryParams,
					pageIndex: action.pageIndex,
					pageSize: action.pageSize,
				},
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(scheduleAList);
